import { Uuid } from "./uuid";
import { NaiveDateTime } from "./datetime";

export default class SignupPage {
    id!: Uuid;
    created!: NaiveDateTime;
    updated!: NaiveDateTime;
    clinic_id!: Uuid;
    title!: string;
    instructions!: string;
    survey!: { title?: string; instructions?: string; items: any[] };
    tags!: string[];
    auto_share_sources!: { entity_type: string; id: Uuid }[];

    static fromJson(data: Object): SignupPage {
        let page = new SignupPage();
        Object.assign(page, data);
        if (!page.survey) {
            page.survey = { items: [] };
        }
        if (!page.survey.items) {
            page.survey.items = [];
        }
        if (!page.tags) {
            page.tags = [];
        }
        if (!page.auto_share_sources) {
            page.auto_share_sources = [];
        }
        return page;
    }

    static newPage(): SignupPage {
        return SignupPage.fromJson({
            id: crypto.randomUUID(),
            title: "",
            instructions: "",
            survey: { items: [] },
            tags: [],
            auto_share_sources: [],
            clinic_id: null,
        });
    }
}
